import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isBrowser } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.PrivacySettings
const label = visitFilterLabelMap[key]

export const privacySettingsColumn = () =>
  columnHelper.display({
    id: 'privacySettings',
    header: 'Privacy Settings',
    cell: ({ row }) => {
      if (!isBrowser(row.original)) {
        return <NotApplicable />
      }

      const result = row.original.privacy_settings

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
